module.exports = __webpack_public_path__ + "img/PPT.95830fa3.svg";